<template lang="pug">
  .container.grid-lg.py-2
    .no-print
      form-filter(@submit="onFilter" :auto-filter='autoFilter' :default-query='q' filter-key='doc-comentarios-filters')

    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        .card.mb-2(v-for="comentario in list" :key='comentario.id')
          .card-header
            .columns
              .column.col-auto
                .card-title.h6 {{ comentario.doc.numero }}/{{ comentario.doc.ano }}
              .column
                .card-subtitle.text-gray.text-small {{ comentario.doc.modelo.descricao }}
          .card-body
            .columns
              item-col.col-auto.mb-2.text-small(label='doc.situacao' :value='comentario.doc.situacao.descricao')
              .column.col-auto.mb-2
                .item-col.text-small
                  .abbr {{ 'doc.cadastro' | tModel }}
                    span(v-if='comentario.doc.cadastro')  {{ comentario.doc.cadastro | enums('cadastro.tipo') }}
                  .small
                    span(v-if='comentario.doc.cadastro') {{ comentario.doc.cadastro.numero }}
                    span(v-else) -
              item-col.col-auto.mb-2.text-small(label='doc.valor_total' :value="comentario.doc.valor_total | currency('R$ ')")
              item-col.col-auto.mb-2.text-small(label='doc.fiscal' :value="comentario.doc.fiscal ? comentario.doc.fiscal.nome : '-'")
              .column.col-auto.mb-2(v-if='comentario.doc.cadastro && comentario.doc.cadastro.contribuinte')
                .item-col.text-small
                  .abbr {{ 'cadastro.contribuinte' | tModel }}
                  .small
                    span {{ comentario.doc.cadastro.contribuinte.cpf_cnpj | cpfCnpj }}
                    span  - {{ comentario.doc.cadastro.contribuinte.razao_social }}
          .card-body
            .text-long.mb-2 {{ comentario.descricao }}
            .columns
              item-col.col-auto.mb-2(label='comentario.realizado_em' :value="comentario.realizado_em | date")
              item-col.col-auto.mb-2(label='doc.comentario_situacao' :value="comentario.comentario_situacao ? comentario.comentario_situacao.descricao : ''")
              .column
              item-col.col-auto.mb-2(label='comentario.usuario' :value="comentario.usuario ? comentario.usuario.nome : ''")
          .card-footer
            .columns
              .column
              .column.col-auto
                router-link.btn.btn-link.tooltip.tooltip-left(
                  :data-tooltip="'views.buttons.show.label' | translate"
                  :to="{name: 'fiscalizacao.docs.show', params: {id: comentario.doc.id}}"
                )
                  btn-content(name='show' label='Exibir Doc')
                a.btn.btn-link(:href='comentario.doc.url' target='_blank')
                  btn-content(name='print')
                a.btn.btn-link(:href='`${comentario.doc.url}.pdf`' target='_blank')
                  btn-content(label='PDF' icon='fa fa-file-pdf-o')
        .my-2.text-right(v-if='pages > 1')
          btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'
import FormFilter from './Filter'

export default {
  vuex: {
    'fiscalizacao/docComentarios': vuexDefaultMapping,
  },

  components: { FormFilter },

  data() {
    return {
      q: { 'doc.id_order_by': 'desc', 'doc.ano_eq': new Date().getFullYear() },
    }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.listar()
    },
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>
